export default {
  root: {
    "&.Mui-focused": {
      color: "inherit"
    }
  }
};
